
import { defineComponent } from "vue";
import router from "@/router";
import {
  GetMetricData,
  GetMetric,
  SummaryTitleByMonth,
  NumberWithCommas,
  GetHighlight,
  ChangeOverTime,
  SourceURL,
  GetDateFromMonthYear,
} from "@/utils";
import Spinner from "@/components/Spinner.vue";
import MetricGrid from "@/components/MetricGrid.vue";
import LineChart from "@/components/Chart/LineChart.vue";
import FilterTabs from "@/components/Chart/FilterTabs.vue";
import MetricTitle from "@/components/MetricTitle.vue";
import SectionTitle from "@/components/SectionTitle.vue";
import MetricStat from "@/components/MetricStat.vue";
import MetricSource from "@/components/MetricSource.vue";
import MetricHighlight from "@/components/MetricHighlight.vue";
import ChartOptions from "@/types/chartOptions";
import Metric from "@/types/metric";

export default defineComponent({
  data() {
    return {
      data: [],
      selectedData: [],
      metric: {} as Metric,
      summaryDate: new Date(),
      latestNumbers: "",
      monthChange: "",
      monthChangePercent: "",
      yearChange: "",
      yearChangePercent: "",
      highlight: "",
      filterOptions: [1, 5, 10, 0],

      //Chart setup
      options: new ChartOptions(),
      dataLabels: ["Percent of Population Employed"],
      dataProps: ["percent_of_population_employed"],
    };
  },
  components: {
    Spinner,
    LineChart,
    MetricGrid,
    MetricTitle,
    SectionTitle,
    FilterTabs,
    MetricStat,
    MetricSource,
    MetricHighlight,
  },
  methods: {
    debug(e: any) {
      console.log("debug", e);
    },
    handleFilter(option: any) {
      this.limitData(option);
    },
    limitData(years: number) {
      /* This is going to be custom for each metric, you need to cin some cases 
        convert the lable to a date. Then limit the date to the intended range */
      if (years == 0) {
        this.selectedData = this.data;
      } else {
        let count = -1 * (12 * years);
        this.selectedData = this.data.slice(count);
      }
    },
    summaryTitle() {
      return SummaryTitleByMonth(this.summaryDate);
    },
    sourceUrl() {
      return SourceURL(this.metric);
    },
  },
  async beforeMount() {
    //@ts-ignore
    const topic = router.currentRoute.value.name; // Get which metric by the route
    this.data = await GetMetricData(topic); // Get raw data from Socrata
    this.metric = GetMetric(topic); // Get metric configuration
    this.selectedData = this.data; // initialize this to "lifetime" and update this variable when a range is selected
    //Add custom chart options
    this.options.scales.yAxis.ticks.callback = (label: any) => {
      return parseInt(label).toFixed(1) + "%";
    };

    // Update tooltip to show percent
    this.options.plugins.tooltip.callbacks.label = (context: any) => {
      return `${context.dataset.label}: ${(context.parsed.y).toFixed(1)}%`
    }

    // Get summary data and hightlights
    const lastItem: any = this.data[this.data.length - 1];
    this.summaryDate = GetDateFromMonthYear(lastItem.date);
    this.latestNumbers = NumberWithCommas(
      lastItem.percent_of_population_employed
    );
    this.monthChange = NumberWithCommas(
      ChangeOverTime(this.data, 1, "percent_of_population_employed", false)
    );
    this.monthChangePercent = ChangeOverTime(
      this.data,
      1,
      "percent_of_population_employed",
      true
    );
    this.yearChange = NumberWithCommas(
      ChangeOverTime(this.data, 12, "percent_of_population_employed", false)
    );
    this.yearChangePercent = ChangeOverTime(
      this.data,
      12,
      "percent_of_population_employed",
      true
    );
    this.highlight = GetHighlight(this.data);
  },
});
